import { render, staticRenderFns } from "./MeasurementsView.vue?vue&type=template&id=58b02999&scoped=true"
import script from "./MeasurementsView.vue?vue&type=script&lang=js"
export * from "./MeasurementsView.vue?vue&type=script&lang=js"
import style0 from "./MeasurementsView.vue?vue&type=style&index=0&id=58b02999&prod&scoped=true&lang=css"
import style1 from "./MeasurementsView.vue?vue&type=style&index=1&id=58b02999&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b02999",
  null
  
)

export default component.exports